import { createActionGroup, emptyProps } from '@ngrx/store';

export const PoiIntlReviewPaymentComponentActions = createActionGroup({
  source: 'POI Intl Review Payment Component',
  events: {
    'Initialize Review Payment Step': emptyProps(),
  },
});
